import React from 'react'
import { Body1, Headline4 } from 'stories/elements/Typography/Text'
import { PrismicImage, PrismicLink } from 'interfaces/GeneratedLandingPage'
import theme from 'stories/utils/theme'
import styled from 'styled-components'

const Container = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    gap: 80px;
    padding-bottom: 50px;
    @media (max-width: 1050px) {
        height: auto;
        gap: 30px;
    }
`

const ArticleDisplay = styled.div`
    display: flex;
    flex-direction: column;
    padding: 25px;
    padding-top: 0;
    grid-gap: 15px;
    row-gap: 15px;
    width: 530px;
    .link {
        all: unset;
        cursor: pointer;
    }
    img {
        cursor: pointer;
        object-fit: scale-down;
    }
    .summary {
        display: block;
        text-overflow: ellipsis;
        word-wrap: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        max-height: 19px * 3;
    }
    @media (max-width: 750px) {
        width: 100%;
        img {
            width: 100%;
            height: auto;
        }
    }
`

interface Props {
    items: {
        image: PrismicImage
        title: string
        text: string
        link: PrismicLink
    }[]
}

const ArticlesShowcaseGrid = ({ items }: Props) => {
    return (
        <Container>
            {items.map(({ image, text, title, link }, i) => (
                <ArticleDisplay key={`article-display-${i}`}>
                    <a href={link.url} target="_blank" rel="noreferrer">
                        <img src={image.url} alt={title} width={500} height={400} />
                    </a>
                    <a href={link.url} target="_blank" rel="noreferrer">
                        <Headline4 color={theme.colors.headlineDark}>{title}</Headline4>
                    </a>
                    <Body1 className="summary">{text}</Body1>
                    <a href={link.url} target="_blank" rel="noreferrer" className="link">
                        <Body1 color={theme.colors.deepSeaBlue}>Mehr lesen</Body1>
                    </a>
                </ArticleDisplay>
            ))}
        </Container>
    )
}

export default ArticlesShowcaseGrid
